import React from "react";
import ReactDOM from "react-dom";
import Tracker from "./components/tracker";
import CssBaseline from "@mui/material/CssBaseline";

ReactDOM.render(
  <React.StrictMode>
    <CssBaseline /> {/* Ensures consistent styling across browsers */}
    <Tracker />
  </React.StrictMode>,
  document.getElementById("root")
);
